module.exports = __webpack_public_path__ + "static/logo-2e79c08ef8925a7e971c5ada3d45f759.png";